import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { toHttpParams } from '../utils/globals';
import { ClassName, PagedList, WorkflowCategoryModel } from '../interface';
import { CategoryResourceService, PagedProductCategoryModel, ProductCategoryModel, SaveResult, UiLabel } from '../vn-api';

@Injectable({
  providedIn: 'root'
})
export class HxCategoryService {
  constructor(
    private httpClient: HttpClient,
    private categoryResourceService: CategoryResourceService,
  ) {
  }

  getWorkflowCategories(params?: {limit?: number; page?: number; query?: string; brandId?: number}): Promise<PagedList<WorkflowCategoryModel>> {
    return firstValueFrom(this.httpClient.get<PagedList<WorkflowCategoryModel>>(`/api/vn/workflows/categories`, { params: toHttpParams(params, true) }));
  }

  getWorkflowCategoryById(categoryId: number): Promise<WorkflowCategoryModel> {
    return firstValueFrom(this.httpClient.get<WorkflowCategoryModel>(`/api/vn/workflows/categories/${categoryId}`));
  }

  saveWorkflowCategory(body: WorkflowCategoryModel): Promise<WorkflowCategoryModel> {
    return firstValueFrom(this.httpClient.post<WorkflowCategoryModel>(`/api/vn/workflows/categories`, body));
  }

  deleteWorkflowCategory(categoryId: number): Promise<WorkflowCategoryModel> {
    return firstValueFrom(this.httpClient.delete<WorkflowCategoryModel>(`/api/vn/workflows/categories/${categoryId}`));
  }

  getCategories(params?: {
    query?: string;
    brandId?: number;
    page?: number;
    limit?: number;
    includeDisabled?: boolean;
    classNames?: ClassName[];
  }): Promise<PagedProductCategoryModel> {
    return firstValueFrom(this.categoryResourceService.getCategoryList(
      params?.brandId,
      params?.classNames,
      undefined,
      params?.includeDisabled,
      params?.limit,
      params?.page,
      params?.query
    ));
  }

  async getCategoriesByIds(ids: number[]): Promise<ProductCategoryModel[]> {
    const paged = await firstValueFrom(this.categoryResourceService.getCategoryList(undefined, undefined, ids));
    return paged.list;
  }

  getCategory(categoryId: number): Promise<ProductCategoryModel> {
    return firstValueFrom(this.categoryResourceService.getCategoryById(categoryId));
  }

  saveCategory(req: ProductCategoryModel): Promise<SaveResult> {
    return firstValueFrom(this.categoryResourceService.saveCategory(req));
  }

  removeCategory(categoryId: number): Promise<any> {
    return firstValueFrom(this.categoryResourceService.removeCategory(categoryId));
  }
}

export interface WorkflowCategoryRequest {
  title: UiLabel;
  displayOrder: number;
}
